import Mixitup from './filter';

class Collection {
  constructor() {
    // this.loadMore()

    this.filterToggles = [].slice.call(
      document.querySelectorAll('.collection__list__filter__toggle')
    );

    this.filterItems = [].slice.call(
      document.querySelectorAll('.filter-item')
    );

    this.filterClearButtons = [].slice.call(
      document.querySelectorAll('.collection__list__filter__clear')
    );

    this.filterToggles.forEach(filterToggle => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        filterToggle.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            const filterList = document.querySelector('.collection__list__filter');
            filterList.classList.toggle('active')
          }
        });
      });
    });

    this.filterItems.forEach(filterItem => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        filterItem.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            const filterListActive = document.querySelector('.mixitup-control-active')
            if (filterListActive === null) {
              this.filterClearButtons.forEach(clearButtons => {
                clearButtons.classList.add('active')
              })
            }
          }
        });
      });
    });

    this.filterClearButtons.forEach(clearButtons => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        clearButtons.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            // TODO: UPDATE THIS AFTER TESTING
            $('.mixitup-control-active').trigger('click');
            this.filterClearButtons.forEach(clearButtons => {
              clearButtons.classList.remove('active')
            })
          }
        });
      });
    });

    Mixitup.container()
  }

  // loadMore() {
  //   // Locate loadmore button
  //   let loadMoreButon = document.querySelector('.collection__list__load-more');
    
  //   // Get URL from the loadMoreButton
  //   let nextUrl = loadMoreButon.getAttribute('href');
  //   loadMoreButon.addEventListener('click', function(e)  {  
  //     e.preventDefault()

  //     // Make ajax call to next page for load more data
  //     $.ajax({
  //       url: nextUrl,
  //       type: 'GET',
  //       beforeSend: function() {
  //         loadMoreButon.remove();
  //       }
  //     })
  //     .done(function(data) {
  //       // Append data
  //       $('.collection__list__products').append($(data).find('.collection__list__products').html());
  //     });
  //   });
  // }
}

const collectionInit = {
  init() {
    // if element exists init this class
    const wrapperEl = document.getElementById('filter-grid');
    if (wrapperEl !== null) {
      // eslint-disable-next-line no-unused-vars
      const collectionWrap = new Collection(wrapperEl);
    }
  },
};

export default collectionInit;
